var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "100px",
    height: "100px",
    viewBox: "-8 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_44.Share",
    "data-name": "44.Share",
    d: "M34,47H14a5,5,0,0,1-5-5V24a5,5,0,0,1,5-5h4a1,1,0,0,1,0,2H14a3,3,0,0,0-3,3V42a3,3,0,0,0,3,3H34a3,3,0,0,0,3-3V24a3,3,0,0,0-3-3H30a1,1,0,0,1,0-2h4a5,5,0,0,1,5,5V42A5,5,0,0,1,34,47ZM31.334,10.715,25,4.381V30a1,1,0,0,1-2,0V4.381l-6.334,6.334a.977.977,0,0,1-1.381-1.381L23.19,1.429a.942.942,0,0,1,.095-.144A.973.973,0,0,1,23.99,1L24,1l.01,0a.973.973,0,0,1,.7.283.882.882,0,0,1,.091.14l7.909,7.909a.977.977,0,1,1-1.381,1.381Z",
    transform: "translate(-9 -1)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f2d6d45fb5c2840e79be257ff0524680.svg";
export { ForwardRef as ReactComponent };